module.exports = __webpack_public_path__ + "d664201f/img/splash-icon.07a7c465.svg";